import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'campaign-step-review' }

import { type PropType } from 'vue'
import { Badge } from 'src/components'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // ongoing campaigns recount every day, so zero today is not a warning
  ongoing: { type: Boolean, default: false },
  // ongoing only: shapes the recipients wording
  conditionType: { type: String, default: 'birthday_in_days' },
  name: { type: String, default: '' },
  audienceChips: { type: Array as PropType<string[]>, default: () => [] },
  previewCount: { type: Number as PropType<number | null>, default: null },
  previewLoading: { type: Boolean, default: false },
  estimatedCost: { type: String, default: '' },
  templateId: { type: Number as PropType<number | null>, default: null },
  templateName: { type: String, default: '' },
  scheduleDisplay: { type: String, default: 'Send now' },
  checklist: { type: Array as PropType<Array<{ key: string; level: string; text: string }>>, default: () => [] },
  testEmail: { type: String, default: '' },
  testSending: { type: Boolean, default: false }
},
  emits: ['update:test-email', 'send-test', 'navigate'],
  setup(__props) {





const checkIcon = (level: string) => {
  if (level === 'pass') return 'tim-icons icon-check-2 text-success'
  if (level === 'warn') return 'tim-icons icon-alert-circle-exc text-warning'
  return 'tim-icons icon-alert-circle-exc text-danger'
}

return { __sfc: true,checkIcon, Badge }
}

})